import Api from "@/config/Api";

export default {
  getProjects(options = {}) {
    return Api().get("/projects", options);
  },
  getProject(id) {
    return Api().get(`/projects/${id}`);
  },
  createProject(data) {
    return Api().post("/projects", data);
  },
  updateProject(id, data) {
    return Api().put(`/projects/${id}`, data);
  },
  deleteProject(id) {
    return Api().delete(`/projects/${id}`);
  },
  attachInvoice(projectId, invoiceId) {
    return Api().post(`/projects/${projectId}/invoices`, {
      invoice_id: invoiceId
    });
  },
  detachInvoice(projectId, invoiceId) {
    return Api().delete(`/projects/${projectId}/invoices/${invoiceId}`);
  },

  // Payments
  getPayments(invoiceId) {
    return Api().get(`/invoices/${invoiceId}/payments`);
  },
  addPayment(invoiceId, data) {
    return Api().post(`/invoices/${invoiceId}/payments`, data);
  },
  updatePayment(invoiceId, paymentId, data) {
    return Api().put(`/invoices/${invoiceId}/payments/${paymentId}`, data);
  },
  deletePayment(invoiceId, paymentId) {
    return Api().delete(`/invoices/${invoiceId}/payments/${paymentId}`);
  },

  // Expenses
  getExpenses(params = {}) {
    return Api().get("/expenses", { params });
  },
  addExpense(data) {
    return Api().post("/expenses", data);
  },
  updateExpense(id, data) {
    return Api().put(`/expenses/${id}`, data);
  },
  deleteExpense(id) {
    return Api().delete(`/expenses/${id}`);
  },

  // Financial summary
  getFinancialSummary(period = "month") {
    return Api().get("/financial-summary", { params: { period } });
  }
};
